export default __webpack_public_path__ + "static/media/sharedgoal.6984a41c.svg";